import Vue from 'vue';
import Router from 'vue-router';
import VueApexCharts from 'vue-apexcharts';
import FAQ from '../components/FAQ.vue';
import Botscore from '../components/Botscore.vue';
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue';

Vue.use(Router);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts)

export default new Router({
  mode: 'history',
  base: '/botamp/',
  routes: [
    {
      path: '/',
      name: 'Botscore',
      component: Botscore
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    }
  ],
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
});
